import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { DownloadManagerCmp } from './download-manager-component';
import { DownloadManagerController } from './download-manager';

export { DownloadManagerController, DownloadOptions } from './download-manager';


export class DownloadManagerModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DownloadManagerModule,
      providers: [
        DownloadManagerController
      ]
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    IonicModule
  ],
  declarations: [
    DownloadManagerCmp
  ],
  exports: [
    DownloadManagerCmp
  ],
  entryComponents: [
    DownloadManagerCmp
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
